export default "__VITE_ASSET__CKse4ckq__"